import { render, staticRenderFns } from "./IdpReport.vue?vue&type=template&id=101dbf4c&scoped=true"
import script from "./IdpReport.vue?vue&type=script&lang=js"
export * from "./IdpReport.vue?vue&type=script&lang=js"
import style0 from "./IdpReport.vue?vue&type=style&index=0&id=101dbf4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101dbf4c",
  null
  
)

export default component.exports